import React, { useRef, useEffect, useState, memo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
    },
    chip: {
        margin: theme.spacing(0.5),
    },
}));

const FilterView = ({ filterTerms, setFilterTerms }) => {

    const classes = useStyles();

    const removeItem = (item) => {
        if (filterTerms != null && item != null) {
            setFilterTerms(f => {
                return f.filter(a => a.label != item.label);
            });
        }
    };

    const old = (
        <div className="filterView">
            { filterTerms && filterTerms.map((item, i) => (
                <div className="filterViewItem" key={i} onClick={() => removeItem(item)}>{item.displayText}</div>
            ))}
        </div>
    );

    return (
        <Paper component="ul" className={classes.root} style={{ boxShadow: "none" }}>
            {filterTerms && filterTerms.map((data, i) => {
                return (
                    <li key={i}>
                        <Chip
                            label={data.displayText}
                            onDelete={() => removeItem(data)}
                            className={classes.chip}
                        />
                    </li>
                );
            })}
        </Paper>
        );

}

export default memo(FilterView);